"use strict";

exports.__esModule = true;
var _QAComponent = require("./QAComponent");
Object.keys(_QAComponent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QAComponent[key]) return;
  exports[key] = _QAComponent[key];
});